<template>
  <div class="modal_s" :style="{maxWidth: width}">
    <div class="header">
      <div class="title">{{ title }}</div>
      <button class="button" @click="close">
        <img src="../../../assets/images/icons/close.svg" alt="">
      </button>
    </div>
    <div class="content" :style="contentStyle">
      <slot></slot>
    </div>
    <div class="footer" v-if="!withoutFooter">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
import {mapMutations} from 'vuex'

export default {
  name: 'With_Header_Modal_Template',
  props: {
    title: String,
    width: {
      required: false,
      type: String,
      default: '1195px',
    },
    withoutFooter: {
      type: Boolean,
      default: false
    },
    emitClose: Boolean,
    contentStyle: String
  },
  methods: {
    ...mapMutations(['closeModals']),
    close() {
      if (this.emitClose) {
        this.$emit('close')
      } else {
        this.closeModals()
      }
    }
  }
}
</script>

<style scoped lang="scss">
.modal_s {
  background-color: #fff;
  width: 100%;
  max-width: 1195px;
}

.header {
  display: flex;
  justify-content: space-between;
  padding: 25px 30px;

  background-color: #DBBFA7;

  .button {
    width: 40px;
    height: 40px;
    background-color: transparent;
    border: none;
  }
}


.title {
  font-family: "Montserrat", "Open Sans", sans-serif;
  font-weight: 600;
  font-size: 32px;
  line-height: 125%;
  color: #383838;
}

.footer {
  background-color: #fff;
  padding: 30px;
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid #E5E5E5;

  button {
    max-width: 320px;
    width: 100%;
    height: 50px;
    background-color: #DBBFA7;
    border-radius: 5px;
    font-weight: 600;
    font-size: 16px;
    line-height: 1;
    color: #383838;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px;

    border: none;

    &:disabled {
      opacity: .7;
    }
  }
}

@media screen and (max-width: 991px){
  .modal_s {
    transform: translateY(10px);
    height: calc(100vh - 20px);
    border-radius: 20px 20px 0 0;
  }

  .header {
    align-items: center;
    padding: 10px 15px;
    border-radius: 20px 20px 0 0;
    .button {
      width: 20px;
      height: 20px;
      img {
        width: 100%;
      }
    }
    .title {
      font-size: 20px;
    }
  }

  .content {
    overflow: auto;
    height: calc(100% - 45px);
  }
}
@media screen and (max-width: 425px){

  .content {
    height: calc(100% - 150px);
  }
}
</style>
